import React from 'react'
import { Header, Table, Button, Message, Form} from 'semantic-ui-react'

import FileImage from '../../filepod/FileImage'
import { MyStore } from "../../../../services/Store"

export function Step3a_Edit(props) {
    if (props.currentStep !== 3) {
        return null
    }

 

    // console.log(props)
    // console.log(props.filelogid)
    // console.log(MyStore.auth().currentUser)
    const  auth = MyStore.auth().currentUser
       
      return (

        <div className="form-group">
             {/* <Header as='h1' textAlign='center'> Checkout</Header> */}
             {/* <Message floated="center" style={{
                            background: "transparent",
                            border: "1px solid transparent",
                            boxShadow: "none",
                            padding: "0em 0em",
                            height: "6vw",
                           
                            // marginLeft: "1.2vw"
                          }}>
                                   <Button  fluid color='green' size='huge' style={{width:"100%" }} >Checkout</Button>
                          </Message> */}


          
    <FileImage auth={auth} filesGroupId={props.filelogid} oid={props.oid}></FileImage>


        </div>
    )
}

 

 